import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
          联系我们
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
          {contactInfo.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <div className="flex items-center gap-2 px-4 md:px-5 py-2.5 md:py-3 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-700 w-full sm:w-auto justify-center cursor-pointer hover:border-primary-300 hover:text-primary-600 transition-all duration-200">
            <i className="ri-mail-line text-base"></i>
            <span>contact@jiubomovie.com</span>
          </div>
          <div className="flex items-center gap-2 px-4 md:px-5 py-2.5 md:py-3 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-700 w-full sm:w-auto justify-center cursor-pointer hover:border-primary-300 hover:text-primary-600 transition-all duration-200">
            <i className="ri-wechat-line text-base"></i>
            <span>微信公众号：久播影院</span>
          </div>
          <div className="flex items-center gap-2 px-4 md:px-5 py-2.5 md:py-3 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-700 w-full sm:w-auto justify-center cursor-pointer hover:border-primary-300 hover:text-primary-600 transition-all duration-200">
            <i className="ri-message-2-line text-base"></i>
            <span>影片推荐 / 反馈建议</span>
          </div>
        </div>
      </div>
    </section>
  );
}